const wnumb = require('wnumb');
const noUiSlider = require('nouislider');
const Storage = require('js-storage');

export default class VdsCalculator {
    constructor(params, callback) {
        // Params element
        this.params = params;

        this.initialTags();
        this.periodSelector();
        this.calculateCpu();
        this.calculateRam();
        this.calculateDisk();
        this.calculatePanel();
        this.clickableMarkers();
        this.calculateTotal();

        if (callback) {
            callback();
        }
    }

    getConfig(attribute) {
        return this.params[attribute];
    }

    initialTags() {
        $('.server-conf-tags__btn').click(function () {
            $('.server-conf-tags__btn').removeClass('server-conf-tags__btn--active')
            $(this).addClass('server-conf-tags__btn--active')
            $('#slider-cpu').get(0).noUiSlider.set($(this).data('cpu'));
            $('#slider-ram').get(0).noUiSlider.set($(this).data('ram'));
            $('#slider-disk').get(0).noUiSlider.set($(this).data('disk'));
        })
    }

    clickableMarkers() {
        $('.noUi-value-large').click(function () {
            $(this).parents('.noUi-target').get(0).noUiSlider.set(
                Math.round($(this).data('value'))
            );
        });
    }

    periodSelector() {
        let self = this;

        // Set default period
        this.period = Storage.localStorage.get('calculator-period') || 'month';

        $('.select-price__link').click(function () {
            self.period = $(this).data('period');

            $('.select-price__link').removeClass('select-price__link--active');

            $(this).addClass('select-price__link--active');

            Storage.localStorage.set('calculator-period', self.period);

            self.calculateTotal();
        });

        $('.select-price__link[data-period=' + this.period + ']').click();
    }

    calculateCpu() {
        // Slider Core
        const slider = $('#slider-cpu').get(0);
        const value = $('#value-cpu').find('span');

        // Variables from attribute
        const count = this.getConfig('cpuCount');
        const step = this.getConfig('cpuStep');
        const max = this.getConfig('cpuMax');
        const price = this.getConfig('cpuPrice');
        const steps = this.getConfig('cpuSteps');

        noUiSlider.create(slider, {
            start: count,
            step: +step,
            tooltips: [wnumb({decimals: 0})],
            connect: 'lower',
            range: this.makeRange(steps.split(',').map(num => parseInt(num))),
            pips: {
                mode: 'values',
                values: steps.split(',').map(num => parseInt(num)),
                format: wnumb({decimals: 0}),
            }
        });

        this.updateValueEvent(slider, value, price, count)
    }

    calculateRam() {
        // Slider RAM
        const slider = $('#slider-ram').get(0);
        const value = $('#value-ram').find('span');

        // Variables from attribute
        const size = this.getConfig('ramSize');
        const step = this.getConfig('ramStep');
        const max = this.getConfig('ramMax');
        const price = this.getConfig('ramPrice');
        const steps = this.getConfig('ramSteps');

        noUiSlider.create(slider, {
            start: size,
            step: +step,
            tooltips: [wnumb({decimals: 0})],
            connect: 'lower',
            range: this.makeRange(steps.split(',').map(num => parseInt(num))),
            pips: {
                mode: 'values',
                values: steps.split(',').map(num => parseInt(num)),
                format: wnumb({decimals: 0})
            }
        });

        this.updateValueEvent(slider, value, price, size)
    }

    calculateDisk() {
        // Slider Disk
        const slider = $('#slider-disk').get(0);
        const value = $('#value-disk').find('span');

        // Variables from attribute
        const size = this.getConfig('diskSize');
        const step = this.getConfig('diskStep');
        const max = this.getConfig('diskMax');
        const price = this.getConfig('diskPrice');
        const steps = this.getConfig('diskSteps');

        noUiSlider.create(slider, {
            start: size,
            step: +step,
            tooltips: [wnumb({decimals: 0})],
            connect: 'lower',
            range: this.makeRange(steps.split(',').map(num => parseInt(num))),
            pips: {
                mode: 'values',
                values: steps.split(',').map(num => parseInt(num)),
                format: wnumb({decimals: 0})
            }
        });

        this.updateValueEvent(slider, value, price / step, size)
    }

    calculatePanel() {
        let self = this;

        $('#value-panel input').change(function () {
            if ($(this).is(':checked')) {
                $('#value-panel').find('span').data('price', self.getConfig('panelPrice'))
            } else {
                $('#value-panel').find('span').data('price', 0)
            }

            self.calculateTotal()
        });
    }

    calculateTotal() {
        let basePrice = Number(this.getConfig('basePrice')),
            cpuPrice = $('#value-cpu').find('span').data('price'),
            ramPrice = $('#value-ram').find('span').data('price'),
            diskPrice = $('#value-disk').find('span').data('price'),
            panelPrice = $('#value-panel').find('span').data('price');

        // Calculate Total Price
        let totalPrice = [
            basePrice,
            cpuPrice,
            ramPrice,
            diskPrice,
            panelPrice
        ].reduce((a, b) => a + b, 0);

        if (this.period === 'day') {
            totalPrice = totalPrice / 31;
        }

        $('.server-conf__price-num').html(
            wnumb({thousand: '&nbsp;', decimals: 2}).to(totalPrice)
        );
    }

    makeRange(values) {
        let res = {
            "min": [Math.min(...values), values[1] - values[0]],
            "max": [Math.max(...values)],
        }

        let step = Math.round(100 / (values.length - 1) * 100) / 100;

        for (let i = 1; i < values.length - 1; i++) {
            res[step * i + '%'] = [values[i], values[i + 1] - values[i]];
        }

        return res;
    }

    updateValueEvent(slider, value, priceOfStep, offset = 0) {
        slider.noUiSlider.on('update', function (values) {
            $(value).html(parseInt(values[0]));
            $(value).data('price', parseInt((values[0] - offset) * priceOfStep));
            this.calculateTotal()
        }.bind(this));
    }
}
